import { useParams } from 'react-router-dom';

import {
  DE_DIRECT_BASE_PATHNAME,
  IWOCA_AFFILIATE_TAG,
  UK_DIRECT_BASE_PATHNAME,
} from '../constants';
import logger from '../utils/logger';

export function useSignupParams() {
  const { affiliateTag } = useParams();

  const isDirectCustomer =
    affiliateTag === UK_DIRECT_BASE_PATHNAME ||
    affiliateTag === DE_DIRECT_BASE_PATHNAME;

  const normaliseAffiliateTag = (): string => {
    if (!affiliateTag) {
      logger.error('Failed to normalise affiliate tag', {
        error: 'No affiliate tag found',
      });

      return IWOCA_AFFILIATE_TAG;
    }

    if (isDirectCustomer) {
      return IWOCA_AFFILIATE_TAG;
    }

    return affiliateTag;
  };

  return {
    rawAffiliateParam: affiliateTag,
    affiliateTag: normaliseAffiliateTag(),
    isDirectCustomer,
    isPartnerCustomer: !isDirectCustomer,
  };
}
